import { isAvailableFromDevToPreProd, isDevOrSandboxOrStaging } from 'reactApp';

export default function (app) {
  app.factory('klConfigService', [
    '$rootScope',
    '$q',
    '$http',
    function ($rootScope, $q, $http) {
      let configPath = '/api/config';
      let _currencies;

      if (document.getElementById('SelfServiceScript')) {
        const scriptElement = document.getElementById('SelfServiceScript');
        configPath = scriptElement.src.substr(0, scriptElement.src.lastIndexOf('/public/cart.bundle.js')) + configPath;
      }

      const _config = $http.get(configPath).then((response) => {
        const config = response.data;
        _currencies = config.currencies;
        $rootScope.$broadcast('klConfigLoaded', {
          config,
        });
        return config;
      });

      function formatAmount(amount, currency) {
        amount = String(parseFloat(amount).toFixed(2));
        const c = findCurrency(currency);
        if (!c) {
          return `${amount} ${currency}`;
        }
        if (c.decimalSymbol === ',') {
          amount = amount.replace(',', '_');
          amount = amount.replace('.', ',');
          amount = amount.replace('_', '.');
        }
        if (c.front) {
          return `${getCurrencySymbol(currency)}${amount}`;
        }
        return `${amount}${getCurrencySymbol(currency)}`;
      }

      function isExternal() {
        return document.domain !== _config.cart.domain;
      }

      function getCurrencySymbol(currency) {
        const c = findCurrency(currency);
        if (c) {
          return c.symbol;
        }
      }

      function getDecimalSymbol(currency) {
        const c = findCurrency(currency);
        if (c) {
          return c.decimalSymbol;
        }
      }

      function getDecimalSymbolClass(currency) {
        const c = findCurrency(currency);
        if (c) {
          return c.decimalSymbolClass;
        }
      }

      function isCurrencySymbolFront(currency) {
        const c = findCurrency(currency);
        if (c) {
          return c.front;
        }
      }

      function findCurrency(currency) {
        if (!_currencies) {
          return;
        }
        for (let i = 0; i < _currencies.length; i++) {
          const c = _currencies[i];
          if (c.type === currency) {
            return c;
          }
        }
      }

      function getCurrencies() {
        return _currencies;
      }

      function getConfig() {
        return _config;
      }

      const isDevOrSandboxOrStagingEnv = () => _config.then(isDevOrSandboxOrStaging);
      const isAvailableFromDevToPreProdEnv = () => _config.then(isAvailableFromDevToPreProd);

      return {
        getConfig,
        isExternal,
        formatAmount,
        getCurrencySymbol,
        getDecimalSymbol,
        getDecimalSymbolClass,
        isCurrencySymbolFront,
        getCurrencies,
        isDevOrSandboxOrStagingEnv,
        isAvailableFromDevToPreProdEnv,
      };
    },
  ]);
}
